import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { DatosSesion } from "../Components/Common/DatosSesion";

const Navdata = () => {
  const history = useNavigate();
  
  // Obtener perfil del usuario para control de acceso
  const perfil = DatosSesion("perfil");
  const isAdmin = perfil === "Administrador" || perfil === "MyHealth";
  const isFarmacia = perfil === "Farmacia";
  const isDelivery = perfil === "Delivery";
  const canAccessSoporte = isAdmin || isFarmacia || isDelivery || perfil === "MyHealth";
  
  //state data
  const [isDashboard, setIsDashboard] = useState(false);
  const [isApps, setIsApps] = useState(false);
  const [isLaboratorios, setIsLaboratorios] = useState(false);
  const [iscurrentState, setIscurrentState] = useState("Dashboard");

  function updateIconSidebar(e) {
    if (e && e.target && e.target.getAttribute("subitems")) {
      const ul = document.getElementById("two-column-menu");
      const iconItems = ul.querySelectorAll(".nav-icon.active");
      let activeIconItems = [...iconItems];
      activeIconItems.forEach((item) => {
        item.classList.remove("active");
        var id = item.getAttribute("subitems");
        if (document.getElementById(id))
          document.getElementById(id).classList.remove("show");
      });
    }
  }

  useEffect(() => {
    document.body.classList.remove("twocolumn-panel");
    if (iscurrentState !== "Dashboard") {
      setIsDashboard(false);
    }

    if (iscurrentState !== "Apps") {
      setIsApps(false);
    }

    if (iscurrentState !== "Laboratorios") {
      setIsLaboratorios(false);
    }
  }, [history, iscurrentState, isDashboard, isApps, isLaboratorios]);

  const menuItems = [
    {
      label: "Menu",
      isHeader: true,
    },
    {
      id: "dashboard",
      label: "Dashboard",
      icon: " ri-apps-line",
      link: "/#",
      stateVariables: isDashboard,
      click: function (e) {
        e.preventDefault();
        //setIsDashboard(!isDashboard);
        setIscurrentState("Dashboard");
        updateIconSidebar(e);
      },
    },

    {
      id: "solicitudes",
      label: "Solicitudes",
      icon: " ri-stack-line",
      link: "/solicitudes",
      stateVariables: isApps,
      click: function (e) {
        e.preventDefault();
        // setIsApps(!isApps);
        setIscurrentState("Solicitudes");
        updateIconSidebar(e);
      },
    },

    {
      id: "motorizado",
      label: "Entregas",
      icon: "ri-e-bike-2-line",
      link: "/motorizado/",
      //stateVariables: isApps,
      click: function (e) {
        e.preventDefault();
        // setIsApps(!isApps);
        //setIscurrentState("Faqs");
        updateIconSidebar(e);
      },
    },

    // Soporte - Solo para Administradores y Farmacias
    ...(canAccessSoporte ? [{
      id: "soporte",
      label: "Soporte",
      icon: "ri-headphone-line",
      link: "/soporte/tickets",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Soporte");
        updateIconSidebar(e);
      },
    }] : []),
   
    {
      id: "reportes",
      label: "Reportes",
      icon: "ri-settings-5-line",
      link: "/#",
      stateVariables: isApps,
      click: function (e) {
        e.preventDefault();
        setIsApps(!isApps);
        setIscurrentState("Apps");
        updateIconSidebar(e);
      },
      subItems: [
        {
          id: "facturacion",
          label: "Facturación",
          icon: "ri-play-list-add-line",
          link: "/reportes/facturacion/",
          click: function (e) {
            e.preventDefault();
            setIscurrentState("Solicitudes");
          },
        },
        {
          id: "siscotel-pendientes",
          label: "Notificaciones de Entregas Pendientes",
          icon: "ri-notification-3-line",
          link: "/reportes/siscotel-pendientes",
          parentId: "reportes",
        },
        {
          id: "reporte-plantas",
          label: "Entregas en Plantas",
          icon: "ri-building-line",
          link: "/plantas/reporte",
          parentId: "reportes",
          click: function (e) {
            e.preventDefault();
            setIscurrentState("ReportePlantas");
          },
        },
        {
          id: "validar-mercantil",
          label: "Validar Mercantil",
          icon: "ri-file-compare-line",
          link: "/reportes/validar-mercantil",
          parentId: "reportes",
        },
      ],
    },

    // Pagos - Solo para Administradores y MyH+
    ...(isAdmin ? [{
      id: "pagos",
      label: "Pagos",
      icon: "ri-money-dollar-circle-line",
      link: "/#",
      stateVariables: isApps,
      click: function (e) {
        e.preventDefault();
        setIsApps(!isApps);
        setIscurrentState("Apps");
        updateIconSidebar(e);
      },
      subItems: [
        {
          id: "importar-pagos",
          label: "Beconsult",
          icon: "ri-file-upload-line",
          link: "/tracking-pagos/importar",
          parentId: "pagos",
          click: function (e) {
            e.preventDefault();
            setIscurrentState("ImportarPagos");
          },
        },
        {
          id: "importar-pagos-mercantil",
          label: "Mercantil",
          icon: "ri-bank-line",
          link: "/tracking-pagos/importar-mercantil",
          parentId: "pagos",
          click: function (e) {
            e.preventDefault();
            setIscurrentState("ImportarPagosMercantil");
          },
        },
      ],
    }] : []),

    {
      id: "configuracion",
      label: "Configuración",
      icon: "ri-settings-5-line",
      link: "/#",
      stateVariables: isApps,
      click: function (e) {
        e.preventDefault();
        setIsApps(!isApps);
        setIscurrentState("Apps");
        updateIconSidebar(e);
      },
      subItems: [
        {
          id: "usuarios",
          label: "Usuarios",
          icon: "ri-play-list-add-line",
          link: "/usuarios/",
          click: function (e) {
            e.preventDefault();
            setIscurrentState("Usuarios");
          },
        },
        {
          id: "Laboratorios",
          label: "Laboratorios",
          icon: "ri-play-list-add-line",
          link: "/laboratorios/",
          click: function (e) {
            e.preventDefault();
            setIscurrentState("Laboratorios");
          },
        },

        {
          id: "PrincipiosActivos",
          label: "Principios Activos",
          icon: "ri-play-list-add-line",
          link: "/principiosactivos/",
          click: function (e) {
            e.preventDefault();
            updateIconSidebar(e);
            setIscurrentState("Principios Activos");
          },
        },

        {
          id: "PrincipiosActivosCategorias",
          label: "Principios Activos Categorias",
          icon: "ri-play-list-add-line",
          link: "/principiosactivoscategorias/",
          click: function (e) {
            e.preventDefault();
            updateIconSidebar(e);
            setIscurrentState("Principios Activos Categorias");
          },
        },

        {
          id: "plantillasmensajes",
          label: "Plantillas Mensajes",
          icon: "ri-play-list-add-line",
          link: "/plantillas-mensajes",
          click: function (e) {
            e.preventDefault();
            setIscurrentState("Plantillas Mensajes");
            updateIconSidebar(e);
          },
        },

        {
          id: "planillaestrategica",
          label: "Planilla Estratégica",
          icon: "ri-play-list-add-line",
          link: "/planilla-estrategica",

          click: function (e) {
            e.preventDefault();
            setIscurrentState("Planilla Estratégica");
            updateIconSidebar(e);
          },
        },

        {
          id: "farmacias",
          label: "Farmacias",
          icon: "ri-play-list-add-line",
          link: "/farmacias",

          click: function (e) {
            e.preventDefault();
            setIscurrentState("Farmacias");
            updateIconSidebar(e); 
          },
        },

        {
          id: "plantas",
          label: "Plantas",
          icon: "ri-building-line",
          link: "/plantas",

          click: function (e) {
            e.preventDefault();
            setIscurrentState("Plantas");
            updateIconSidebar(e); 
          },
        },
      ],
    },
  ];

  switch (perfil?.trim()) {
    case "Delivery":
      // Para Delivery: Entregas y Soporte
      const entregas = menuItems.find(item => item.id === "motorizado");
      const soporteDelivery = menuItems.find(item => item.id === "soporte");
      const elementosDelivery = [entregas, soporteDelivery].filter(item => item !== undefined); 
      menuItems.splice(0, menuItems.length, ...elementosDelivery);
      break;
    case "Farmacia":
      // Para Farmacia: Dashboard, Solicitudes, Soporte, Reportes (SIN Entregas ni Configuración)
      const elementosDeseados = [
        menuItems.find(item => item.id === "dashboard"),
        menuItems.find(item => item.id === "solicitudes"),
        menuItems.find(item => item.id === "soporte"),
        menuItems.find(item => item.id === "reportes"),
      ].filter(item => item !== undefined);
      menuItems.splice(0, menuItems.length, ...elementosDeseados);
      break;
    case "MyHealth":
      const elementosDeseados2 = [
        menuItems.find(item => item.id === "dashboard"),
        menuItems.find(item => item.id === "solicitudes"),
        menuItems.find(item => item.id === "soporte"),
      ].filter(item => item !== undefined);
      menuItems.splice(0, menuItems.length, ...elementosDeseados2);
      break;

    default:
      break;
  }

  const filteredMenuItems = menuItems.filter(item => item !== undefined);
  return <React.Fragment>{filteredMenuItems}</React.Fragment>;
};
export default Navdata;
